import tap from 'redux-tap';
import toPairs from 'lodash.topairs';
import metrics from 'metrics';

const mapToKeyValuePairs = ([key, value]) => `${key}:${value}`;

export default () => {
  const selectMetricsMeta = ({ meta }) => meta && meta.metrics;

  return tap(selectMetricsMeta, meta => {
    const { name, tags = {} } = meta;
    const tagPairs = toPairs(tags).map(mapToKeyValuePairs);

    metrics.count('actions', [`action-name:${name}`, ...tagPairs]);
  });
};



/** WEBPACK FOOTER **
 ** ./app/store/middleware/createMetricsMiddleware.js
 **/